var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-panel", class: [_vm.rootClasses] },
    [
      _c("transition", { attrs: { name: "trs-header-panel-switch" } }, [
        !_vm.isLocation
          ? _c(
              "div",
              {
                key: "main",
                staticClass: "header-panel--main",
                style: _vm.scrollLockStyles
              },
              [
                _c(
                  "div",
                  { staticClass: "header-panel--brand" },
                  [
                    _c("transition", { attrs: { name: "trs-simple-fade" } }, [
                      _vm.isContent || _vm.isHomeIntroDismissed
                        ? _c(
                            "a",
                            {
                              staticClass: "u-reset header-panel--home-link",
                              attrs: { href: _vm.partial.content.home_link.to },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.onHomeLinkRequested()
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "header-panel--logo",
                                attrs: {
                                  src: _vm._f("static")("img/im_vehi-logo.svg"),
                                  alt: ""
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "header-panel--nav" },
                  [
                    !_vm.isMobile
                      ? _c("cmp-main-nav", {
                          attrs: { facet: "base", "has-rail": true }
                        })
                      : _c("cmp-mobile-nav-toggle")
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.isMobile
                  ? _c("div", { staticClass: "header-panel--rail" })
                  : _vm._e()
              ]
            )
          : _c(
              "div",
              { key: "detail", staticClass: "header-panel--detail" },
              [
                _c(
                  "router-link",
                  _vm._b(
                    {
                      staticClass:
                        "btn btn__large btn__bubble btn__light header-panel--back-link"
                    },
                    "router-link",
                    _vm.partial.content.home_link,
                    false
                  ),
                  [
                    _c("cmp-icon", {
                      attrs: { symbol: "chevron-left", size: "small" }
                    })
                  ],
                  1
                )
              ],
              1
            )
      ]),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "trs-mobile-nav-toggle" },
          on: {
            enter: _vm.onScrollLockEnterHook,
            afterLeave: _vm.onScrollLockAfterLeaveHook
          }
        },
        [
          _vm.isMobile && _vm.navigation.mobile.isOpen
            ? _c("cmp-main-nav", {
                staticClass: "header-panel--mobile-nav",
                attrs: { facet: "mobile" }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4ccea1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4ccea1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/header-panel/index.vue
// module id = 350
// module chunks = 5